<template>
    <Transition
        name="fast-fade"
        mode="out-in">
        <div
            v-if="isHoverModel && tab.tooltip"
            class="pointer-events-none fixed z-40 mr-4 w-auto text-16/148"
            :style="{
                left: left + 16 + 'px',
                top: top + 16 + 'px',
            }">
            <div
                class="group relative z-20 flex size-full h-auto items-center overflow-hidden rounded-20 before:absolute before:left-0 before:top-0 before:z-20 before:size-full before:w-full before:overflow-hidden before:rounded-20 before:bg-accent-700/50 before:shadow-[0px_0px_35px_0px_transparent_inset] before:shadow-[#FFFFFF80]">
                <div
                    class="absolute left-0 z-20 h-full w-auto overflow-hidden rounded-20">
                    <div class="bg-noise"></div>
                </div>

                <div class="absolute z-10 size-full bg-accent-700"></div>

                <div class="pointer-events-none relative z-20 px-5 py-3">
                    {{ tab.tooltip }}
                </div>
            </div>
        </div>
    </Transition>
</template>

<script setup lang="ts">
import type { TabInfo } from '~/components/particles/first-screen/tab.types'

interface Props {
    isHoverModel: boolean
    tab: TabInfo
    top: number
    left: number
}

defineProps<Props>()
</script>
